import { atom } from "jotai";
import { loadable } from "jotai/utils";

import type { GeojsonResponse } from "../types";

const fileURLs = {
  countries: "https://utfs.io/f/c831d3c3-70c3-4c8c-83f0-d1bf5c54fdc1-kpskzr.geojson",
  boroughs: "https://utfs.io/f/725aaab8-2a21-40d2-b234-84a03ec04185-q75ub2.geojson",
  cities: "https://utfs.io/f/b91747d9-e71c-4196-b3d6-0229b99b55b9-dyvg7e.geojson",
  districts: "https://utfs.io/f/fd91a49d-e0bc-4a3d-863d-ca85240b5f37-3o2glg.geojson",
};

export const asyncLayersQuery = atom(async () => {
  const country = await getGeoJson(fileURLs.countries);
  const district = await getGeoJson(fileURLs.districts);
  const city = await getGeoJson(fileURLs.cities);
  const borough = await getGeoJson(fileURLs.boroughs);

  const highlight = (geojson: any) => ({
    ...geojson,
    features: geojson.features.map((feature) => {
      return {
        ...feature,
        properties: {
          ...feature.properties,
          "custom-color": "#3cf1c6",
        },
      };
    }),
  });

  const layers = {
    country: highlight(country),
    county: highlight(district),
    city: highlight(city),
    borough: highlight(borough),
  };

  return layers;
});

export const layersQuery = loadable(asyncLayersQuery);

const getGeoJson = async (geojson: string) => {
  try {
    const res = await fetch(geojson);
    const layers = (await res.json()) as GeojsonResponse;

    return {
      type: layers.type,
      features: layers.features,
    };
  } catch (e) {
    console.error("ERROR GET geojson", e);
  }
};
